import { render, staticRenderFns } from "./PracticeAssessment.vue?vue&type=template&id=e5360974"
import script from "./PracticeAssessment.vue?vue&type=script&lang=ts"
export * from "./PracticeAssessment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports